export default function redirectToLogin () {
  // don't add redirect for logout
  if (window.location.pathname.endsWith('/logout')) {
    window.location = '/login'
    return
  }

  const redirect = encodeURIComponent(`${window.location.pathname}${window.location.search}`)
  window.location = `/login?redirect=${redirect}`
}



// WEBPACK FOOTER //
// ../webmango-utils/redirect.js